import React, { useEffect, useRef, useState } from "react";
import Body from "../../components/body/BodyPage";
import MainLinks from "../../components/navlinks/MainLinks";
import { useTranslation } from "react-i18next";
import {
  MDBAlert,
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBBtn,
  MDBCol,
  MDBRow,
  MDBScrollspy,
  MDBScrollspyLink,
  MDBSpinner,
} from "mdb-react-ui-kit";
import { useLocation, useNavigate } from "react-router";
import SMSBrandDetails from "../smsbrand/SMSBrandDetails";
import SMSBrandContactsDetails from "../smsbrand/SMSBrandContactsDetails";
import {
  getSpecificSMSBrandDetails,
  updateSMSBrand,
} from "../../apiclients/streamsapi_bridge";
import { useForm } from "react-hook-form";
import TopSuccess from "../../components/header/TopSuccess";
import TopMessage from "../../components/header/TopMessage";
import SaveChanges from "../../components/topviews/saveCancel";
import { useAdminContext } from "../../components/adminstore/Admin-Context";
import EditWarning from "../../components/header/EditWarning";
import ProofDocuments from "../smsbrand/ProofDocuments";
function BrandCompanyRegistration() {
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();

  const containerRef = useRef(null);
  const section1 = useRef(null);
  const section2 = useRef(null);
  const section3 = useRef(null);
  const location = useLocation();
  const [isloading, setIsloading] = useState(false);
  const [rerender, setRerender] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [internalError, setInternalError] = useState("");
  const [BrandInfo, setBrandInfo] = useState(
    location.state ? location.state : {},
  );
  const [orgType, setorgType] = useState(0);
  const { isEdited, setEdited } = useAdminContext();
  const [targetView, setTargetView] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);
  const [uploadedexistFiles, setuploadedExistFiles] = useState([]);
  const [uploadDBFiles, setuploadDBFiles] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [hasProofDocsKey, setHasProofDocsKey] = useState(false);
  const [brandstatus, setbrandstatus] = useState("");
  const [isBrandEdit, setisBrandEdit] = useState(true);
  const isPPLogin = (JSON.parse(sessionStorage.getItem("admin_session"))?.loggedInFromPP === true) ?? false;
  const [brandName, setBrandName] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  const {
    register,
    setValue,
    getValues,
    watch,
    formState: { isDirty, dirtyFields, errors },
    reset,
    handleSubmit,
    setError,
    clearErrors,
    control,
  } = useForm({
    defaultValues: {
      brand_details: {
        city: "",
        state: 0,
        street: "",
        country: "",
        countryName: "",
        website: "",
        zipcode: "",
        org_type: "0",
        org_type_name: "",
        brand_name: "",
        tax_number: "",
        company_name: "",
        duns_giin_lei: "",
        duns_giin_lei_num: "",
        vertical_type: "",
        stock_symbol: "",
        stock_exchange: 0,
        location_id: 0,
        billing_group_id: 1,
      },
      contact_details: {
        phno: "",
        email: "",
        contact_name: "",
      },
    },
  });

  const handleOk = () => {
    setEdited(false);
    if (targetView.indexOf("/") !== -1) {
      navigate(targetView);
    }
    setShowWarning(false);
  };

  useEffect(() => {
    if (BrandInfo.brand_id || rerender) {
      getBrandSpecificDetails();
    }
  }, [BrandInfo, rerender]);

  async function getBrandSpecificDetails() {
    try {
      setIsloading(true);
      const response = await getSpecificSMSBrandDetails(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        BrandInfo.brand_id,
      );
      setTimeout(() => {
        setIsloading(false);
      }, 1000);
      const brandDetails = await response.json();
      console.log(
        "getSpecific getBrandSpecificDetails ::: " +
          JSON.stringify(brandDetails)
      );
      //   setusers(faxgroupdetails?.users ?? []);
      //   setdids(faxgroupdetails?.attributes?.did ?? []);
      
      // Check if proof_docs key exists in the response
      const hasProofDocs = brandDetails.hasOwnProperty('proof_docs');
      setHasProofDocsKey(hasProofDocs);
      
      setuploadedExistFiles(brandDetails?.proof_docs ?? []);
      setuploadDBFiles(brandDetails?.proof_docs ?? []);
      setorgType(
        brandDetails?.brand_details?.org_type?.id
          ? parseInt(brandDetails?.brand_details?.org_type?.id)
          : 0,
      );
      setBrandName(brandDetails?.brand_details?.brand_name ?? "");
      setbrandstatus(brandDetails?.brand_status ?? "");
      setisBrandEdit(brandDetails?.isInitiated !== undefined ? brandDetails?.isInitiated === 1 ? false : true : true);

      reset({
        brand_details: {
          city: brandDetails?.brand_details?.city ?? "",
          state: brandDetails?.brand_details?.state ?? 0,
          street: brandDetails?.brand_details?.street ?? "",
          country: brandDetails?.brand_details?.country?.cscode  ?? 0,
          countryName: brandDetails?.brand_details?.country?.cname  ?? "",
          website: brandDetails?.brand_details?.website ?? "",
          zipcode: brandDetails?.brand_details?.zipcode ?? "",
          org_type: brandDetails?.brand_details?.org_type?.org_type_id ?? "0",
          org_type_name: brandDetails?.brand_details?.org_type?.org_type_name ?? "",
          brand_name: brandDetails?.brand_details?.brand_name ?? "",
          tax_number: brandDetails?.brand_details?.tax_number ?? "",
          company_name: brandDetails?.brand_details?.company_name ?? "",
          duns_giin_lei: brandDetails?.brand_details?.duns_giin_lei ?? "",
          duns_giin_lei_num:
            brandDetails?.brand_details?.duns_giin_lei_num ?? "",
          vertical_type: brandDetails?.brand_details?.vertical_type ?? "",
          stock_symbol: brandDetails?.brand_details?.stock_symbol ?? "",
          stock_exchange: brandDetails?.brand_details?.stock_exchange ?? 0,
          location_id: brandDetails?.brand_details?.location_id ?? 0,
          billing_group_id: brandDetails?.brand_details?.billing_group_id ?? 1,
        },
        contact_details: {
          phno: brandDetails?.contact_details?.phno ?? "",
          email: brandDetails?.contact_details?.email ?? "",
          contact_name: brandDetails?.contact_details?.contact_name ?? "",
        },
      });

      setRerender(false);
    } catch (error) {}
  }

  const isSave = Object.keys(dirtyFields).length === 0 ? false : true;

  useEffect(() => {
    setEdited(isSave);
  }, [isSave]);

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();

      // Add basic fields
      formData.append("reqid", 162);
      formData.append(
        "siteid",
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      );
      formData.append(
        "brand_id",
        BrandInfo?.brand_id ? String(BrandInfo.brand_id) : "",
      );

      // Add modified fields
      for (const field of Object.keys(dirtyFields)) {
        // Skip deletepdfs as it's handled separately below
        if (field === "deletepdfs") continue;

        let modifiedData = {};
        if (dirtyFields[field] && data.hasOwnProperty(field)) {
          if (typeof data[field] === "object" && !Array.isArray(data[field])) {
            // For nested objects like brand_details and contact_details, flatten them
            for (const subfield of Object.keys(dirtyFields[field])) {
              if (data[field].hasOwnProperty(subfield)) {
                // Append each subfield directly to formData instead of nesting
                formData.append(subfield, data[field][subfield]);
              }
            }
          } else {
            // For arrays, keep the existing logic
            modifiedData = [...data[field]];
            formData.append(field, JSON.stringify(modifiedData));
          }
        }
      }

      // Add proof documents if available
      if (uploadedFiles && uploadedFiles.length > 0) {
        uploadedFiles.forEach((file) => {
          formData.append("proof_docs", file.file, file.name);
        });
      }

      // Add deletepdfs if available (handled once here)
      const deletePdfs = watch("deletepdfs");
      if (deletePdfs && deletePdfs.length > 0) {
        deletePdfs.forEach((deleteid) => {
          formData.append("deletepdfs", deleteid);
        });
      }

      console.log("FormData entries:");
      for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }

      setIsloading(true);
      let saverep = await updateSMSBrand(formData);
      console.log(`response of updateSMSBrand :::: ${JSON.stringify(saverep)}`);
      let saverepeMsg = await saverep.json();
      console.log(
        "response of modified data updateSMSBrand  :::" +
          JSON.stringify(saverepeMsg),
      );
      setTimeout(() => {
        setIsloading(false);
      }, 1000);

      if (saverepeMsg.status && saverepeMsg.status == "success") {
        setRerender(true);
        setSuccessMessage(saverepeMsg.message);
        // Clear uploaded files after successful save
        setUploadedFiles([]);
      } else {
        if (saverepeMsg.message?.errors) {
          saverepeMsg.message.errors.forEach((err) => {
            setError(err.param_name, {
              type: "server",
              message: err.message,
            });
            const fieldElement = document.querySelector(
              `input[name="${err.param_name}"]`,
            );
            if (fieldElement) {
              fieldElement.focus();
              fieldElement.scrollIntoView({ behavior: "smooth" });
            }
          });
        } else {
          setInternalError(saverepeMsg.message || "Internal Server Error");
        }
      }
    } catch (error) {
      console.log(`Error: ${error}`);
      setIsloading(false);
    }
  };
  function closeSave(e) {
    reset();
    setRerender(true);
  }

  return (
    <React.Fragment>
      <>
        <MainLinks active={2} />
        <Body
          tablinks={2}
          sublink={270}
          content={
            <>
              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header py-3 px-0">
                    <h5 className="mb-0 ">
                      <MDBBreadcrumb>
                        <MDBBreadcrumbItem>
                          <a
                            onClick={(e) => {
                              if (isEdited) {
                                setTargetView("/phonenumbers");
                                setShowWarning(true);
                                return;
                              }
                              navigate("/phonenumbers");
                            }}
                          >
                            <strong>Phone System</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>
                          <a
                            onClick={(e) => {
                              if (isEdited) {
                                setTargetView("/smslanding");
                                setShowWarning(true);
                                return;
                              }
                              navigate("/smslanding");
                            }}
                          >
                            <strong>SMS Registration</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem>
                          <a href="">
                            <strong>
                              {BrandInfo.brand_details.brand_name}
                            </strong>
                          </a>
                        </MDBBreadcrumbItem>
                      </MDBBreadcrumb>
                    </h5>
                  </div>
                  <div className="card-body px-0">
                    <div className="pb-2">
                      <h5 className="fw-600 mt-2 ">
                       {brandName}
                      </h5>
                      <p className="mt-2 text-secondary">
                        {typeof BrandInfo.brand_id === "string" &&
                        isNaN(Number(BrandInfo.brand_id))
                          ? "Brand ID: " + BrandInfo.brand_id
                          : ""}
                      </p>
                      <strong className="mt-3 mb-0">
                        Status: {brandstatus}
                      </strong>
                    </div>

                    <div className="routing-border pt-0 my-2"></div>

                    <MDBRow>
                      <MDBCol md="2">
                        <MDBScrollspy container={containerRef}>
                          <MDBScrollspyLink targetRef={section1}>
                            Brand Details
                          </MDBScrollspyLink>
                          <MDBScrollspyLink targetRef={section2}>
                            Contact Details
                          </MDBScrollspyLink>
                          {hasProofDocsKey && (
                            <MDBScrollspyLink targetRef={section3}>
                              Proof of Documents
                            </MDBScrollspyLink>
                          )}
                        </MDBScrollspy>
                      </MDBCol>

                      <MDBCol md="8">
                        <div
                          id="element"
                          ref={containerRef}
                          className="scrollspy-example"
                          style={{paddingBottom:"6rem"}}
                        >
                          <section ref={section1} id="section-1"
                            className={(brandstatus === "Pending" && !isBrandEdit) || (brandstatus === "Approved" && !isPPLogin) ? "disabled-form cursor-notAllowed" : ""}
                            {...(((brandstatus === "Pending" && !isBrandEdit) || (brandstatus === "Approved" && !isPPLogin)) && {
                              title: brandstatus === "Approved"
                                ? `This brand is ${brandstatus}. Only Location and Billing Group can be edited — please contact the LNP Team for other changes.`
                                : "This brand's registration request is currently pending approval, so its details cannot be edited until the review is complete.",
                              onClick: (e) => {
                                if (e.target.closest(".always-editable")) return;
                                e.preventDefault();
                                e.stopPropagation();
                              },
                            })}>
                            <SMSBrandDetails
                              register={register}
                              watch={watch}
                              errors={errors}
                              setValue={setValue}
                              orgType={orgType}
                              clearErrors={clearErrors}
                              isLoading={isloading}
                              setIsLoading={setIsloading}
                              control={control}
                              brandstatus={brandstatus}
                            />
                          </section>
                          <div className="routing-border mt-2"></div>
                          <section ref={section2} id="section-2"
                            className={(brandstatus === "Pending" && !isBrandEdit) || (brandstatus === "Approved" && !isPPLogin) ? "disabled-form cursor-notAllowed" : ""}
                            {...(((brandstatus === "Pending" && !isBrandEdit) || (brandstatus === "Approved" && !isPPLogin)) && {
                              title: brandstatus === "Approved"
                                ? `This brand is ${brandstatus}. Only Location and Billing Group can be edited — please contact the LNP Team for other changes.`
                                : "This brand's registration request is currently pending approval, so its details cannot be edited until the review is complete.",
                              onClick: (e) => { e.preventDefault(); e.stopPropagation(); },
                            })}>
                            <SMSBrandContactsDetails
                              register={register}
                              watch={watch}
                              errors={errors}
                              setValue={setValue}
                            />
                          </section>
                          {/* {hasProofDocsKey && ( */}
                            <>
                             {hasProofDocsKey && (  <div className="routing-border mt-2"></div>)}
                              <section ref={section3} id="section-3" style={{ display: hasProofDocsKey ? "block" : "none" }}>
                                <ProofDocuments
                                  register={register}
                                  watch={watch}
                                  errors={errors}
                                  setValue={setValue}
                                  uploadedexistFiles={uploadedexistFiles}
                                  uploadedFiles={uploadedFiles}
                                  setUploadedFiles={setUploadedFiles}
                                  brandid={BrandInfo.brand_id}
                                  setIsloading={setIsloading}
                                  brandstatus={brandstatus}
                                />
                              </section>
                            </>
                          {/* )} */}
                        </div>
                        {(isSave || uploadedFiles?.length > 0) && (
                          <SaveChanges
                            onClose={closeSave}
                            isdirtyFields={isSave}
                            onSave={(e) => {
                              e.preventDefault();
                              handleSubmit(onSubmit)();
                            }}
                          />
                        )}
                      </MDBCol>
                    </MDBRow>
                  </div>
                </div>
              </section>
              {successMessage && (
                <>
                  <TopSuccess>
                    <TopMessage successMessage={successMessage} />
                  </TopSuccess>
                </>
              )}
              {isloading && (
                <>
                  <div className="loadingclass">
                    <MDBBtn disabled>
                      <MDBSpinner
                        size="sm"
                        role="status"
                        tag="span"
                        className="me-2"
                      />
                      Loading...
                    </MDBBtn>
                  </div>
                </>
              )}
            </>
          }
        />
        {showWarning && (
          <EditWarning
            warningToggle={warningToggle}
            setShowWarning={setShowWarning}
            onOk={handleOk}
          />
        )}
        {internalError && (
          <MDBAlert
            open
            className="alert-center"
            color="danger"
            autohide
            position="bottom-right"
            delay={5000}
            onClose={() => setInternalError("")}
          >
            {internalError ?? "Internal Server Error"}
          </MDBAlert>
        )}
      </>
    </React.Fragment>
  );
}

export default BrandCompanyRegistration;
